
import axios from "axios";
const wellknown = require("wellknown");
import { mapState } from "vuex";
import enterPlon from "./components/enterPlon";
import concactDialog from "./components/concact-dialog.vue";
import wxLocation from "./components/wx-location.vue";
import {
  searchParkLocation,
  getAttributeByLocation,
  enterpriseSearch,
  enterpriseInfo,
} from "@/api/enterprise";
import { getBd092cj02 } from "@/api/user";
import Legend from "./components/legend";
import Layer from "./components/layer";
import multipleSelection from "./components/multipleSelection";
import MapMeasureTool from "@/components/mapboxgl-measure-tool";
import VRAndImaging from "./components/VRAndImaging";
import searchAddress from "./components/searchAddress";
import rightMenu from "./components/right-menu";
import sourceLayerJson from "@/data/sourceLayer.config";
import splitPane from "@/components/split-pane";
import concact from "./components/concact";
import layerController from "./components/layer-controller";
import operation from "./components/operation";
import PlotWidget from "@/components/mapbox-plugins/PlotWidget";
import projectContainer from "./components/project-container";
import rightReportPanel from "./components/right-report-panel";
import guide from "@/layouts/components/guide";
import layer1 from "@/data/layer1_new.json";
import layer2 from "@/data/layer2_new.json";
import layer3 from "@/data/layer3_new.json";
import layer4 from "@/data/layer4_new.json";
import layer5 from "@/data/layer5_new.json";
import { DbJson } from "@/mixins/dbJson";
import { getToken } from '@/utils/auth'
// import Plot from '@/components/mapbox-plugins/index'
// const layer1 = require('https://cyy.pcmxj.com/data/layer1.json')
// import Map from '@arcgis/core/Map'
// import MapView from '@arcgis/core/views/MapView'
// import { loadModules } from "esri-loader";
// 数据格式
// 实现图层展示和测距功能
// 实现图例功能
// 实现透明度功能
// 实现筛选企业图层功能
// 实现右键隐藏框选
// 实现VR
// 实现影像图
// 实现右键菜单
// 实现右键下载企业名录
// 右键清除标注

//  把图层封装成通用组件，读取CAD配置文件,方便后续的法定图册等等的图层更新
//  增加联系方式
//  增加操作手册
//  增加企业注册
//  增加城市图层的分类
//  修改企业详情细节
//  实现move的时候鼠标为当前鼠标

// 1、保存一下项目
// 2、
// 移到 mounted 钩子中执行，避免 SSR hydration 问题

export default {
  layout: "default",
  components: {
    enterPlon,
    Legend,
    Layer,
    VRAndImaging,
    searchAddress,
    rightMenu,
    splitPane,
    concact,
    concactDialog,
    wxLocation,
    operation,
    layerController,
    projectContainer,
    guide,
    rightReportPanel,
    multipleSelection,
    // Plot
  },
  mixins: [DbJson],
  data() {
    let flattenChildren = (children) =>
      children.flatMap((item) => [
        item,
        ...(item.children ? flattenChildren(item.children) : []),
      ]);
    let layerDatas = [
      ...flattenChildren(layer1.data),
      ...flattenChildren(layer2.data),
      ...flattenChildren(layer3.data),
      ...flattenChildren(layer4.data),
      ...layer5.data,
    ];
    return {
      keyTypeSelect: "1",
      dMapLoading: false,
      accessToken:
        "pk.eyJ1IjoicXE5NjIwNTUyOTgiLCJhIjoiY2xnZGQxazluMTNldjN1bzdpY2dscDJrOSJ9.RqSTnlvvrdwizUkew51Gnw",
      building: null,
      placeholderTxt: "搜索园区 / 企业 / 位置信息",
      isHoverUnclustered: false,
      layerId: "", // 图层id
      layerName: "", // 图层名称
      layer_name: "", // 图层编号
      persplit: 100,
      moveCheckValsLength: 0,
      pop_choose: false,
      showResize: false,
      isLayerLock: false, //判断是否为业务图层
      isFinite: false, // 判断是否为业务图层
      originCheckVal: layerDatas, // 原图层一维数组
      markerList: [],
      checkedVals: [], // 选中打开的图层
      legEndList: [],
      filtercodes: [], // ��选企业图层
      imageLayers: [], //图片图层
      defaultFeatures: [
        "buildings",
        "industrial_park",
        "szcsgxlxsj1227",
        "industrial_upstairs",
        "szgyqkxmy",
        "park_20",
        "tdzb",
        "jhlx",
        "sszt",
        "zxgh",
        "lytdzbpfgg",
        "yghcags",
        "ygbghtg",
        "ynrzbjhjd",
        "yghgg",
        "ybqbcazxyxynrgs",
        "yssfagg",
        "qt",
        "technology_park_20",
        "economy_park_40",
      ], // geoserver图层
      showPaneR: false, // 是否显示右侧面板
      moveCheckVals: [
        {
          label: "现状建筑",
          isChcek: true,
          checkVal: 20,
          optVal: 80,
          keyName: "buildings",
          key: "buildings",
        },
      ],
      mapvglView: null,
      map: null,
      iframeUrl: "", // 航拍URL
      iframeUrlCase: "",
      isHouer3D: false, // 判断是否为3D地图
      hoveredStateId: null,
      featureId: null,
      popDesc_click: null,
      industrial_park_featureId: null,
      popDesc_industrial_park: null,
      pop_setting_formataddr: null,
      mapTool: null,
      nearScatterLayer: null,
      popDesc_supporting_dormitory: null,
      popDesc_supporting_dormitoryId: null,
      popDesc_industrial_upstairs: null,
      industrial_upstairs_featureId: null,
      pop_szcsgxlxsj1227_Desc: null,
      feature_szcsgxlxsj1227_Id: null,
      popDesc_rail_stations_park: null,
      rail_stations_featureId: null,
      pop_szgyqkxmy_Desc: null,
      feature_szgyqkxmy_Id: null,
      st_asgeojson: null,
      centerPoint: null,
      fHover: null,
      layers: null,
      baidu_pop_choose: null,
      moveTimer: null,
      zoom: 16.5,
      popDesc: null,
      geoCircleJson: null,
      dbJson: {},
      origJson: {},
      rightclickInfo: {},
      searchInput: "",
      // center: [],
      clickLngLat: { lng: 113.94563077274017, lat: 22.5353444034467 },
      isIn: false, // 是否绘制面
      isProjectLayer: false,
      isHourArea: false,
      isHourLine: false,
      isViewData: true, // 是否查询属性
      moreSearchBtn: false,
      isMarker: false, // 是否标记
      isPoint: true,
      contextMenuVisible: false,
      parkInfo: {},
      renderedPoints: [],
      layerPoints: [],
      mapEvents: ["click", "touchend"],
      chart: null,
      isJieJingView: false,
    };
  },
  computed: {
    ...mapState("app", ["isCloseRight"]),
  },
  beforeRouteLeave(to, from, next) {
    // 确保只在客户端执行清理操作
    if (process.client && typeof window !== 'undefined') {
      if (window.widget) {
        try {
          window.widget.plotManager.draw.removeDraw(); // 从地图实例中移除 Draw
          window.widget = null;
        } catch (error) {
          console.warn('清理 widget 失败:', error);
        }
      }
      try {
        $(".mapboxgl-ctrl-group").remove();
        this.$layer && this.$layer.closeAll();
        if (this.building) {
          this.building.stop();
          // 移除地图容器
          this.building.remove();
          // 释放地图对象引用
          this.building = null;
        }
      } catch (error) {
        console.warn('清理地图资源失败:', error);
      }
    }
    next((vm) => { });
  },
  destroyed() { },
  watch: {},
  mounted() {
    // 定义全局错误处理函数（只在客户端）
    if (process.client && typeof window !== 'undefined') {
      window.handleImageError = function () {
        try {
          document.getElementById("baiduImage").src =
            "https://qntz.pcmxj.com/wxapp_static/st-noresult.png";
        } catch (error) { }
      };
    }

    // 显示加载提示
    console.log('🚀 开始初始化地图...');
    
    // 等待 AMap 加载完成
    this.waitForAMap()
      .then(() => {
        console.log('📍 准备初始化地图实例...');
        // 获取用户代理字符串
        var userAgent = navigator.userAgent;
        // 判断是否为谷歌内核
        if (
          userAgent.indexOf("Chrome") !== -1 &&
          userAgent.indexOf("AppleWebKit") !== -1
        ) {
          this.ini();
        } else {
          this.toCurrent();
        }
      })
      .catch((error) => {
        console.error('❌ 地图加载失败:', error);
        // 即使加载失败也尝试初始化（可能 AMap 已经部分加载）
        if (window.AMap) {
          console.log('⚠️ AMap 部分可用，尝试初始化...');
          this.ini();
        } else {
          console.error('❌ AMap 完全不可用，请检查网络连接');
        }
      });
  },
  notifications: {
    showLocationSuccss: {
      // You can have any name you want instead of 'showLoginError'
      title: `您当前园区为`,
      message: `已为您定位到`,
      type: "success", // You also can use 'VueNotifications.types.error' instead of 'error'
    },
  },
  methods: {
    // 等待 AMap 加载完成（只在客户端）
    waitForAMap() {
      return new Promise((resolve, reject) => {
        // 服务端直接返回
        if (typeof window === 'undefined') {
          resolve();
          return;
        }
        
        // 客户端检查 AMap 是否已加载
        if (window.AMap) {
          console.log('✅ AMap 已加载');
          resolve();
          return;
        }
        
        console.log('⏳ 等待 AMap 加载... 请稍候');
        let checkCount = 0;
        const maxChecks = 300; // 增加到 30 秒（300 * 100ms）
        
        const checkInterval = setInterval(() => {
          checkCount++;
          
          // 每 5 秒显示进度
          if (checkCount % 50 === 0) {
            console.log(`⏳ 已等待 ${checkCount / 10} 秒...`);
          }
          
          if (window.AMap) {
            clearInterval(checkInterval);
            console.log('✅ AMap 加载成功');
            resolve();
          } else if (checkCount >= maxChecks) {
            clearInterval(checkInterval);
            console.error('❌ AMap 加载超时（30秒）');
            
            // 检查脚本是否存在
            const amapScript = document.querySelector('script[src*="webapi.amap.com"]');
            if (!amapScript) {
              console.error('❌ AMap 脚本标签未找到！');
              if (this.$toasted) {
                this.$toasted.error('地图脚本未加载，请检查网络连接', {
                  position: 'top-center',
                  duration: 8000
                });
              }
            } else {
              console.warn('⚠️ AMap 脚本存在但未执行完成，可能是网络问题');
              if (this.$toasted) {
                this.$toasted.error('地图加载超时，请检查网络连接或刷新页面', {
                  position: 'top-center',
                  duration: 8000
                });
              }
            }
            
            // 即使超时也尝试初始化（可能 AMap 部分加载了）
            resolve();
          }
        }, 100);
      });
    },
    // 底图改变
    async baseMapChanged(isChanged) {
      await this.$refs.layerComp.getCheckedVals();
      this.$refs.layerControllerPop.doShowBaseMap(isChanged);
    },
    doReportProject() {
      this.doProjectReportPanel();
    },
    closeRightPage() {
      this.persplit = 100;
      this.showResize = false;
      this.showPaneR = false;
      this.$nextTick(() => {
        this.resize();
      });
    },
    // 项目报告导出
    doNotProjectReportPanel() {
      this.persplit = 50;
      this.showResize = true;
      this.showPaneR = true;
      this.$store.commit("app/doCloseRight", false);
      this.$nextTick(() => {
        this.resize();
      });
    },
    // 项目报告导出
    doProjectReportPanel() {
      this.persplit = 50;
      this.showResize = true;
      this.showPaneR = true;
      this.$nextTick(() => {
        // 把id写到store里面去
        // 生成1分30秒到2分钟之间的毫秒数
        const minMilliseconds = 90 * 1000; // 1分30秒的毫秒数
        const maxMilliseconds = 2 * 60 * 1000; // 2分钟的毫秒数
        const randomMilliseconds =
          Math.floor(Math.random() * (maxMilliseconds - minMilliseconds + 1)) +
          minMilliseconds;
        this.$refs.rightReportPanelRef.doFakeUpload(randomMilliseconds);
        this.resize();
      });
    },
    addProjectsLayerToMap(isLayerToMap) {
      if (isLayerToMap) {
        this.isPoint = false;
        // this.isViewData = false;
      }
      this.isProjectLayer = isLayerToMap;
    },
    inProjectDraw(isIn) {
      if (isIn) {
        this.isPoint = false;
        // this.isViewData = false;
        this.isIn = true;
      } else {
        this.isIn = false;
        this.isPoint = true;
        // this.isViewData = false;
      }
    },
    changeDrawerState(isOpen) {
      this.$refs.legendRef.changeState(isOpen);
      this.$refs.VRMap.changeState(isOpen);
    },
    getChangeLayers(layers) {
      this.$refs.layerComp.sameCheck(layers);
    },
    handleConcactUs() {
      this.$refs.concactDialogPop.showPop();
    },
    resize() {
      const zoom = this.building.getZoom();
      this.building.resize();
      this.setZoomAndCenter(zoom);
    },

    getCompaniesState(companyState) { },
    async doGetAddress(item) {
      if (item.location) {
        let lnglat = item.location.split(",");
        this.setZoomAndCenter(18, lnglat);
        this.toPlaceAndPoint(lnglat);
        if (item.value && item.address) {
          setTimeout(() => {
            this.showLocationSuccss({
              title: `已为您定位到${item.value}`,
              message: `位置：${item.address}`,
              type: "success",
              timeout: 3000,
            });
          }, 5000);
        } else if (item.address) {
          setTimeout(() => {
            this.showLocationSuccss({
              title: `已为您定位到${item.address}`,
              message: "",
              type: "success",
              timeout: 3000,
            });
          }, 5000);
        }
      } else {
        const res = await enterpriseInfo({
          route: "enterprise/getLongitudeAndLatitude",
          credit_no: item.credit_no,
          type: 1,
        });
        const ret = await enterpriseInfo({
          route: "enterprise/getBasicInfo",
          credit_no: item.credit_no,
        });
        if (res.data) {
          this.$refs.enterRef.setListOne(ret.data);
          item.location = `${res.data.longitude},${res.data.latitude}`;
          let lnglat = item.location.split(",");
          this.setZoomAndCenter(18, lnglat);
          this.toPlaceAndPoint(lnglat);
          if (item.value && item.address) {
            setTimeout(() => {
              this.showLocationSuccss({
                title: `已为您定位到${item.value}`,
                message: `位置：${item.address}`,
                type: "success",
                timeout: 3000,
              });
            }, 5000);
          } else if (item.address) {
            setTimeout(() => {
              this.showLocationSuccss({
                title: `已为您定位到${item.address}`,
                message: "",
                type: "success",
                timeout: 3000,
              });
            }, 5000);
          }
        }
      }
    },

    toPlaceAndPoint(lnglat) {
      try {
        if (Number(lnglat[0]) != NaN && Number(lnglat[1]) != NaN) {
          this.getPoiName(lnglat);
          this.addCenter(lnglat);
        }
      } catch (error) { }
    },
    doSelect1(selectValue) {
      this.$refs.enterRef.toAroundTheCompanies({
        gb_industry_category: selectValue,
      });
      this.$refs.enterRef.showPop();
    },
    doSelect2(selectValue) {
      this.$refs.enterRef.toAroundTheCompanies({
        gb_industry_primary: selectValue,
      });
      this.$refs.enterRef.showPop();
    },

    doSelect3(selectValue) {
      this.$refs.enterRef.toAroundTheCompanies({
        gb_industry_middle: selectValue,
      });
      this.$refs.enterRef.showPop();
    },

    doChanyeSelect1(selectValue) {
      this.$refs.enterRef.toAroundTheCompanies({
        industry_category: selectValue,
      });
      this.$refs.enterRef.showPop();
    },

    doChanyeSelect2(selectValue) {
      this.$refs.enterRef.toAroundTheCompanies({
        industry_subcategory: selectValue,
      });
      this.$refs.enterRef.showPop();
    },

    doQiYeSelect1(selectValue) {
      this.$refs.enterRef.toAroundTheCompanies({
        company_type_category: selectValue,
      });
      this.$refs.enterRef.showPop();
    },

    doQiYeSelect2(selectValue) {
      this.$refs.enterRef.toAroundTheCompanies({
        company_type_subcategory: selectValue,
      });
      this.$refs.enterRef.showPop();
    },

    getLayersForMap({ checkedVals, changeLayer }) {
      let arr = this.originCheckVal.map((item) => {
        return { label: item.label, key: item.key };
      });
      arr.forEach((item) => {
        if (item.key instanceof Array) {
          item.key.forEach((key) => {
            if (this.building.getLayer(key)) {
              this.building.setLayoutProperty(key, "visibility", "none");
            }
          });
        } else {
          if (this.building.getLayer(item.key)) {
            this.building.setLayoutProperty(item.key, "visibility", "none");
          }
        }
      });
      this.checkedVals = this.deepClone(checkedVals);
      if (
        this.checkedVals[0] &&
        this.checkedVals[0].keyName.indexOf("fyqqwzt") > -1
      ) {
        // this.building.setPitch(45);
        // this.map.setPitch(45)
        this.setZoomAndCenter(18, [113.79723494018958, 22.690215171621418]);
      }
      this.checkedVals.forEach((item, index) => {
        if (item.key instanceof Array) {
          item.key.forEach((key) => {
            if (this.building.getLayer(key)) {
              // console.log(item.key)
              this.building.setLayoutProperty(key, "visibility", "visible");
            } else if (key.indexOf("custom_project_") > -1) {
              this.building.getStyle().layers.forEach((layer) => {
                if (layer.id.startsWith(key)) {
                  this.building.setLayoutProperty(
                    layer.id,
                    "visibility",
                    "visible"
                  );
                }
              });
            } else {
              // console.log(key)
              let url =
                process.env.NODE_ENV === "dev"
                  ? `http://119.29.128.126:6080/arcgis/rest/services/${key}/MapServer/export?dpi=96&transparent=true&format=png8&layers=&bbox={bbox-epsg-3857}&f=image&bboxSR=102100&imageSR=102100`
                  : `https://cyy.pcmxj.com/arcgis_server/arcgis/rest/services/${key}/MapServer/export?dpi=96&transparent=true&format=png8&layers=&bbox={bbox-epsg-3857}&f=image&bboxSR=102100&imageSR=102100`;

              this.building.addSource(key, {
                type: "raster",
                tiles: [url],
                tileSize: 256,
              });
              this.building.addLayer({
                id: key,
                type: "raster",
                source: key,
                "source-layer": key,
                layout: {
                  visibility: "visible",
                },
                paint: {
                  "raster-opacity": 1,
                },
                minzoom: item.minzoom || 10,
                maxzoom: 21,
              });
            }
          });
        } else {
          if (this.building.getLayer(item.key)) {
            // console.log(item.key)
            this.building.setLayoutProperty(item.key, "visibility", "visible");
          } else {
            // console.log(item.key)
            let url =
              process.env.NODE_ENV === "dev"
                ? `http://119.29.128.126:6080/arcgis/rest/services/${item.key}/MapServer/export?dpi=96&transparent=true&format=png8&layers=&bbox={bbox-epsg-3857}&f=image&bboxSR=102100&imageSR=102100`
                : `https://cyy.pcmxj.com/arcgis_server/arcgis/rest/services/${item.key}/MapServer/export?dpi=96&transparent=true&format=png8&layers=&bbox={bbox-epsg-3857}&f=image&bboxSR=102100&imageSR=102100`;
            this.building.addSource(item.key, {
              type: "raster",
              tiles: [url],
              tileSize: 256,
            });
            this.building.addLayer({
              id: item.key,
              type: "raster",
              source: item.key,
              "source-layer": item.key,
              layout: {
                visibility: "visible",
              },
              paint: {
                "raster-opacity": 1,
              },
              minzoom: 10,
              maxzoom: 21,
            });
          }
        }
      });
      this.move(this.checkedVals);
      if (changeLayer) {
        this.$refs.layerControllerPop.showPop(this.checkedVals);
      }
      this.$refs.legendRef.showPop(this.checkedVals);
    },
    moveAnddictSelectPolygon(polygons) {
      // console.log(JSON.stringify(polygons))
      // debugger
      // 合并所有多边形的点
      let allPoints = polygons.flat(2);

      // 计算边界框
      let bounds = allPoints.reduce(
        (bounds, coord) => bounds.extend(coord),
        new mapboxgl.LngLatBounds(allPoints[0], allPoints[0])
      );

      // 计算边界框的宽度和高度
      let width = bounds.getEast() - bounds.getWest();
      let height = bounds.getNorth() - bounds.getSouth();

      // 根据边界框的宽度和高度确定 maxZoom 的值
      let maxZoom;
      if (width > 0.1 || height > 0.1) {
        maxZoom = 12;
      } else if (width > 0.01 || height > 0.01) {
        maxZoom = 14;
      } else {
        maxZoom = 16;
      }
      // 移动并缩放地图
      this.building.fitBounds(bounds, {
        padding: { top: 10, bottom: 25, left: 15, right: 5 },
        maxZoom: maxZoom,
      });
    },
    move(ar) {
      this.moveCheckVals = this.deepClone(ar);
      this.moveCheckVals.forEach((item, index) => {
        if (item.key instanceof Array) {
          item.key.forEach((key) => {
            if (this.building.getLayer(key)) {
              this.building.moveLayer(key);
            }
          });
        } else {
          if (this.building.getLayer(item.keyName)) {
            this.building.moveLayer(item.keyName);
          }
        }
      });
      let layers = this.building.getStyle().layers;
      let layerA = layers.filter((item) => {
        return item.id.indexOf("field_txt") > -1;
      });
      layerA.forEach((item) => {
        this.building.moveLayer(item.id);
      });
      let layerS = layers.filter((item) => {
        return (
          item.id.indexOf("gl-draw-polygon") > -1 ||
          item.id.indexOf("custom_project_") > -1
        );
      });
      layerS.forEach((item) => {
        this.building.moveLayer(item.id);
      });

      if (
        this.moveCheckVals[this.moveCheckVals.length - 1] &&
        this.moveCheckVals[this.moveCheckVals.length - 1]["keyName"] &&
        this.moveCheckVals[this.moveCheckVals.length - 1]["keyName"].startsWith(
          "custom_project_"
        )
      ) {
        let sources = this.building.getStyle().sources;
        let coords = [];
        for (let key in sources) {
          if (
            key.startsWith(
              `${this.moveCheckVals[this.moveCheckVals.length - 1]["keyName"]}`
            )
          ) {
            coords.push(sources[key].data.geometry.coordinates);
            // 你可以在这里对源执行其他操作
          }
        }
        this.moveAnddictSelectPolygon(coords);
      }
    },
    sumPoints(str) {
      const regex = /POINT\((\d+\.\d+)\s+(\d+\.\d+)\)/;
      const match = str.match(regex);

      if (match) {
        const longitude = parseFloat(match[1]);
        const latitude = parseFloat(match[2]);

        // console.log(`经度: ${longitude}, 纬度: ${latitude}`);
        return [longitude, latitude, 10];
      }
      return [];
    },

    generateReport() {
      this.$toasted.show("暂未开放", { position: "top-center", duration: 500 });
    },

    clearArea(params) {
      if (this.st_asgeojson) {
        // this.building.removeLayer('maine')
        this.building.removeLayer("outline");
        this.building.removeSource("maine");

        this.st_asgeojson = null;
      } else {
        this.$toasted.show("未找到选区，请重试", {
          position: "top-center",
          duration: 500,
        });
      }
    },

    // https://map.baidu.com/?qt=ipLocation
    async getLocationFrom() {
      const res = await axios.get(
        process.env.NODE_ENV === "dev"
          ? "/apibaidu?qt=ipLocation"
          : "https://map.baidu.com?qt=ipLocation"
      );
      if (res.data.rgc && res.data.rgc.result && res.data.rgc.result.location) {
        let ret = res.data.rgc.result.location;
        const reb = await getBd092cj02({ lng: ret.lng, lat: ret.lat });
        const lnt = this.sumPoints(reb.data.st_astext);
        this.clickLngLat = { lng: lnt[0], lat: lnt[1] };
      }
    },

    // 取消绘制
    stopDraw() {
      widget.plotManager.draw.mapboxDraw.trash();
      this.isIn = false;
    },
    clearPoint() {
      if (this.building.getLayer("pointClusters")) {
        this.building.removeLayer("pointClusters");
        this.building.removeLayer("cluster-count");
        this.building.removeLayer("unclustered-points");
        this.building.removeSource("points");
      }
      if (this.st_asgeojson) {
        // this.building.removeLayer('maine')
        this.building.removeLayer("outline");
        this.building.removeSource("maine");

        this.st_asgeojson = null;
      }
      if (this.markerList.length > 0) {
        this.markerList.forEach((item) => {
          item.marker.remove();
          item.pop.remove();
        });
        this.markerList = [];
      }
    },

    addCenter(center) {
      if (this.centerPoint) {
        this.centerPoint.remove();
      }

      let el = document.createElement("div");
      el.className = "center-marker";
      this.centerPoint = new mapboxgl.Marker(el)
        .setLngLat(center)
        .addTo(this.building);
    },
    metersToPixelsAtMaxZoom(meters, latitude) {
      return meters / 0.075 / Math.cos((latitude * Math.PI) / 180);
    },

    createGeoJSONCircle(center, radiusInKm, points) {
      if (!points) points = 64;

      let coords = {
        latitude: center[1],
        longitude: center[0],
      };

      let km = radiusInKm;

      let ret = [];
      let distanceX =
        km / (111.32 * Math.cos((coords.latitude * Math.PI) / 180));
      let distanceY = km / 110.574;

      let theta, x, y;
      for (let i = 0; i < points; i++) {
        theta = (i / points) * (2 * Math.PI);
        x = distanceX * Math.cos(theta);
        y = distanceY * Math.sin(theta);
        ret.push([coords.longitude + x, coords.latitude + y]);
      }
      ret.push(ret[0]);

      return {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Polygon",
                coordinates: [ret],
              },
            },
          ],
        },
      };
    },
    closeProject() {
      this.isProjectLayer = false;
    },
    getAdjacentPoints(point) {
      const offset = 100 / 1000 / 111;
      // 计算纬度
      const lat1 = point[1] - offset;
      const lat2 = point[1] + offset;

      // 计算经度（考虑纬度的影响）
      const lngOffset = offset / Math.cos((point[1] * Math.PI) / 180);
      const lng1 = point[0] - lngOffset;
      const lng2 = point[0] + lngOffset;

      return [
        [lng1, lat1],
        [lng2, lat2],
      ];
    },
    async toCurrent() {
      let that = this;
      // 确保 AMap 已加载
      if (typeof window === 'undefined' || !window.AMap) {
        console.warn('AMap 尚未加载完成，直接初始化');
        that.ini();
        return;
      }
      
      try {
        AMap.plugin("AMap.Geolocation", function () {
          var geolocation = new AMap.Geolocation({
            // 是否使用高精度定位，默认：true
            enableHighAccuracy: true,
            // 设置定位超时时间，默认：无穷大
            timeout: 10000,
            // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
            buttonOffset: new AMap.Pixel(10, 20),
            //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
            zoomToAccuracy: true,
            //  定位按钮的排放位置,  RB表示右下
            buttonPosition: "RB",
          });

          geolocation.getCurrentPosition(function (status, result) {
            if (status == "complete") {
              that.onComplete(result);
            } else {
              that.onError(result);
            }
          });
        });
      } catch (error) {
        console.error('AMap 定位失败:', error);
        that.ini();
      }
    },
    onComplete(data) {
      this.clickLngLat = { lng: data.position.lng, lat: data.position.lat };
      // data是具体的定位信息
      this.ini();
    },
    onError(data) {
      // 定位出错
      this.ini();
    },
    async ini() {
      // 确保只在客户端执行
      if (typeof window === 'undefined') {
        console.warn('服务端环境，跳过地图初始化');
        return;
      }
      
      if (!window.AMap) {
        console.error('AMap 未加载，无法初始化地图');
        return;
      }
      
      if (!window.mapboxgl) {
        console.error('Mapbox GL 未加载，无法初始化地图');
        return;
      }
      
      try {
        mapboxgl.config.MAX_PARALLEL_IMAGE_REQUESTS = 256;
        mapboxgl.accessToken = this.accessToken;
        let dbJson = await this.doLayers();
        // await this.getLocationFrom()
        this.map = new AMap.Map("map", {
        center: [this.clickLngLat.lng, this.clickLngLat.lat],
        // showIndoorMap:true,
        features: ["point", "road", "bg"],
        zoom: this.zoom + 1,
        pitch: 0,
        rotation: 0,
        rotationEnable: true,
        animateEnable: false,
        viewMode: "3D", //开启3D视图,默认为关闭
      });

      this.building = new mapboxgl.Map({
        container: "building",
        renderWorldCopies: false, // 可选：禁用复制地球的渲染，以改善显示
        // 设置插值模式
        transformRequest: (url, resourceType) => {
          if (
            resourceType === "Tile" &&
            url.includes("your_raster_source_url")
          ) {
            return {
              url: url,
              headers: {
                "Mapbox-GL-JS-Interpolation-Mode": "nearest", // 使用最近邻插值
              },
            };
          }
        },
        ...this.getCommonParams(),
        style: dbJson,
        // 'http://new.zy.pccstz.com/pbmap/static/config/osmdatasv7.json' // //'http://new.zy.pccstz.com/pbmap/static/config/osmdatasv7.json',
      });

      // this.loca = new Loca.Container({
      //   map: this.map,
      // });
      this.building.on("load", async () => {
        this.initSetting();

        // 获取参数?layer=1
        let layer = this.$route.query.layer;
        if (layer) {
          let lng = this.$route.query.lng;
          let lat = this.$route.query.lat;
          // 设置中心点
          this.setZoomAndCenter(17, [lng, lat]);

          // 勾选图层
          this.$refs.layerComp.handleCheckedChange(layer);
          // getLayersForMap
          this.getLayersForMap({
            checkedVals: [
              {
                label: "",
                isChcek: true,
                checkVal: 20,
                optVal: 80,
                keyName: layer,
                key: layer,
              },
            ],
            changeLayer: true,
          });

          // 是否登录
          if (!getToken()) {
            this.$store.dispatch('user/resetToken')
            // 弹窗提示
            // this.$toasted.show('请先登录', { position: 'top-center', duration: 5000 })
          }

          // 显示图层
          // this.building.setLayoutProperty(layer, "visibility", "visible");
          // 显示属性
          const data = await this.drawParkByLayer(layer, lng, lat);
          const hstr = this.formatJsonToHtml(
            layer,
            sourceLayerJson,
            data[0],
            lng,
            lat
          );
          this.popDesc_click = new mapboxgl.Popup({
            offset: 25,
            closeOnClick: false,
          })
            .setLngLat({ lng, lat })
            .setHTML(hstr)
            .addTo(this.building);

          let externalClass = "mapboxgl-mycalss";
          $(".mapboxgl-popup-content").addClass(externalClass);
          // 拖动事件
          this.doDragPanel();
          // 如果是拆赔，显示拆赔信息
          if (layer == "cpal") {
            this.showCallClaim(data[0].name);
          }
        }
      });
      } catch (error) {
        console.error('地图初始化失败:', error);
        this.$toasted && this.$toasted.error('地图加载失败，请刷新页面重试', {
          position: 'top-center',
          duration: 3000
        });
      }
    },

    dragEnd(ar1) {
      this.moveCheckVals = ar1;
    },

    webMercatorToWGS84(x, y) {
      let lon = (x / 20037508.34) * 180;
      let lat = (y / 20037508.34) * 180;
      lat =
        (180 / Math.PI) *
        (2 * Math.atan(Math.exp((lat * Math.PI) / 180)) - Math.PI / 2);
      return [lon, lat];
    },

    async doLayers() {
      const res =
        process.env.NODE_ENV === "dev"
          ? await axios.get("/json/config/style.json")
          : await axios.get("/config/style.json");

      let dbJson = res.data; // this.deepClone(res.data)

      dbJson = this.setDbJson(dbJson);
      return dbJson;
    },

    initArcGisLayer() {
      let arr = layer2.data.filter((item) => {
        return item.isImage;
      });
      let arr1 = layer1.data.filter((item) => {
        return item.isImage;
      });
      const ar = [...arr, ...arr1];

      ar.forEach((item, ind) => {
        this.building.addSource(item.keyName, {
          type: "raster",
          tiles: [
            process.env.NODE_ENV === "dev"
              ? `http://119.29.128.126:6080/arcgis/rest/services/${item.keyName}/MapServer/export?dpi=512&transparent=true&format=png8&layers=&bbox={bbox-epsg-3857}&f=image&bboxSR=102100&imageSR=102100`
              : `https://cyy.pcmxj.com/arcgis_server/arcgis/rest/services/${item.keyName}/MapServer/export?dpi=512&transparent=true&format=png8&layers=&bbox={bbox-epsg-3857}&f=image&bboxSR=102100&imageSR=102100`,
          ],
          tileSize: 256,
        });

        this.building.addLayer({
          id: item.keyName,
          type: "raster",
          source: item.keyName,
          "source-layer": item.keyName,
          layout: {
            visibility: item.isChcek ? "visible" : "none",
          },
          paint: {
            "raster-opacity": parseInt(item.optVal, 10) / 100,
          },
          minzoom: item.minzoom || 10,
          maxzoom: 21,
        });
        if (ar[ind - 1]) {
          this.building.moveLayer(item.keyName);
        }
      });

      this.building.setLayoutProperty(
        layer2.data[0].keyName,
        "visibility",
        layer2.data[0].isChcek ? "visible" : "none"
      );

      this.building.addSource("fdtz_unlabel", {
        type: "raster",
        tiles: [
          process.env.NODE_ENV === "dev"
            ? `http://119.29.128.126:6080/arcgis/rest/services/fdtz_unlabel/MapServer/export?dpi=96&transparent=true&format=png8&layers=&bbox={bbox-epsg-3857}&f=image&bboxSR=102100&imageSR=102100`
            : `https://cyy.pcmxj.com/arcgis_server/arcgis/rest/services/fdtz_unlabel/MapServer/export?dpi=96&transparent=true&format=png8&layers=&bbox={bbox-epsg-3857}&f=image&bboxSR=102100&imageSR=102100`,
        ],
        tileSize: 256,
      });

      // 额外的图层 -- 未在配置中显示
      this.building.addLayer({
        id: "fdtz_unlabel",
        type: "raster",
        source: "fdtz_unlabel",
        "source-layer": "fdtz_unlabel",
        layout: {
          visibility: "none",
        },
        paint: {
          "raster-opacity": 1,
        },
        minzoom: 10,
        maxzoom: 21,
      });
    },
    arrayDimension(arr) {
      if (!Array.isArray(arr)) {
        return 0; // 不是数组，返回0
      }

      // 如果是数组，检查其元素
      let maxDim = 0;
      for (let i = 0; i < arr.length; i++) {
        maxDim = Math.max(maxDim, this.arrayDimension(arr[i]));
      }
      return 1 + maxDim; // 返回当前维度+子数组的最大维度
    },
    // 创建多个多边形
    parseMul(wktString) {
      // 将多边形变成单边形
      const geoJson = wellknown.parse(wktString);
      // 创建一个空的特性数组
      const features = [];
      const polys = [];
      if (this.arrayDimension(geoJson.coordinates) == 3) {
        features.push({
          type: "Feature",
          properties: {},
          geometry: {
            type: "Polygon",
            coordinates: geoJson.coordinates,
          },
        });
        polys.push(geoJson.coordinates);
      } else {
        // 遍历每个 Polygon 并将它们添加到特性数组中
        for (let poly of geoJson.coordinates) {
          polys.push(poly);
        }
      }
      let geodJson = {
        type: "MultiPolygon",
        coordinates: polys,
      };
      this.draw_st_asgeojson(JSON.stringify(geodJson));

      this.moveAnddictSelectPolygon(polys);
    },

    async doLayerSearch(item) {

      if(item.layer_name == 'cadastral_data'){
        let layer = item.layer_name;
        // 使用 export 服务
        // 直接勾选图层
        // 勾选图层
        this.$refs.layerComp.handleCheckedChange(layer);
          // getLayersForMap
        this.getLayersForMap({
            checkedVals: [
              {
                label: "",
                isChcek: true,
                checkVal: 20,
                optVal: 80,
                keyName: layer,
                key: layer,
              },
            ],
            changeLayer: true,
          });
      }


      await this.$refs.layerComp.showPop();
      this.$nextTick(() => {
        let visib = this.building.getLayoutProperty(
          item.layer_name,
          "visibility"
        );
        if (visib == "none") {
          $(`#layer_bome_${item.layer_name}`).click();
        }
        setTimeout(() => {
          this.building.moveLayer(item.layer_name);
          this.parseMul(item.wkt);
        });
      });
    },
    // 地址搜索
    searchToAddress() {
      this.$refs.searchAddressRef.showSearchDialog();
    },
    // 根据ID获取园区坐标画区域
    async drawParkByLayer(layer, lng, lat, isDraw = true) {
      const res = await getAttributeByLocation({ layer, lng, lat });
      if (res && res.data.length > 0 && isDraw) {
        this.draw_st_asgeojson(res.data[0].st_asgeojson);
      }
      return res.data;
    },

    draw_st_asgeojson(st_asgeojson) {
      if (this.building.getLayer("outline")) {
        this.building.removeLayer("outline");
        this.building.removeSource("maine");
        this.st_asgeojson = null;
      }
      this.st_asgeojson = JSON.parse(st_asgeojson);
      this.building.addSource("maine", {
        type: "geojson",
        data: {
          type: "Feature",
          geometry: {
            type:
              this.st_asgeojson.type == "MultiPolygon"
                ? "MultiPolygon"
                : "Polygon",
            // These coordinates outline Maine.
            coordinates: this.st_asgeojson.coordinates,
          },
        },
      });

      this.building.addLayer({
        id: "outline",
        type: "line",
        source: "maine",
        layout: {
          // "zindex": 1
        },
        paint: {
          "line-color": "#00ff00",
          "line-dasharray": [2, 2],
          "line-width": 3,
        },
      });
      this.building.moveLayer("outline");
    },
    changeTyepSelect() {
      if (this.keyTypeSelect == 1) {
        this.placeholderTxt = "搜索园区 / 企业 / 位置信息";
      } else {
        this.placeholderTxt = "搜索企业名称查询";
      }
    },
    async drawParkByLayerAndShowPop(layer, lng, lat) {
      if (layer.startsWith("custom_project_")) {
        this.moveCheckValsLength--;
        this.drawParkByLayerAndShowPop(
          this.moveCheckVals[this.moveCheckValsLength]["keyName"],
          lng,
          lat
        );
        return;
      }
      layer = this.changeLayerName(layer);
      const data = await this.drawParkByLayer(layer, lng, lat);
      if (this.popDesc_click) {
        this.popDesc_click.remove();
        this.popDesc_click = null;
      }
      if (data.length > 0) {
        const hstr = this.formatJsonToHtml(
          layer,
          sourceLayerJson,
          data[0],
          lng,
          lat
        );
        this.popDesc_click = new mapboxgl.Popup({
          offset: 25,
          closeOnClick: false,
        })
          .setLngLat({ lng, lat })
          .setHTML(hstr)
          .addTo(this.building);
        let externalClass = "mapboxgl-mycalss";
        $(".mapboxgl-popup-content").addClass(externalClass);
        // 拖动事件
        this.doDragPanel();
        // 如果是拆赔，显示拆赔信息
        if (layer == "cpal") {
          this.showCallClaim(data[0].name);
        }
      } else {
        this.moveCheckValsLength--;
        if (this.moveCheckValsLength > -1) {
          this.drawParkByLayerAndShowPop(
            this.moveCheckVals[this.moveCheckValsLength]["keyName"],
            lng,
            lat
          );
        }
      }
    },
    // 显示拆赔信息
    showCallClaim(pro_name) {
      let that = this;
      if (!this.showResize) {
        this.persplit = 50;
        this.showResize = true;
        this.iframeUrlCase = `https://www.zgszcy.com/projects/${pro_name}.html?a=${Math.floor(
          Math.random() * 10
        )}`;
        this.$nextTick(() => {
          this.$refs.enterRef.hideOnBtn();
          this.building.resize();
        });
      } else {
        this.iframeUrlCase = `https://www.zgszcy.com/projects/${pro_name}.html?a=${Math.floor(
          Math.random() * 10
        )}`;
      }
    },
    changeLayerName(layer) {
      if (layer == "track") {
        layer = "track_line";
      }

      if (layer == "sz_bus") {
        layer = "sz_bus_point";
      }

      if (layer == "zxgh") {
        layer = "szcsgxlxsj1227";
      }
      if (layer == "sszt") {
        layer = "szcsgxlxsj1227";
      }

      if (layer == "jhlx") {
        layer = "szcsgxlxsj1227";
      }

      if (layer == "lytdzbpfgg") {
        layer = "tdzb";
      }
      if (layer == "yghcags") {
        layer = "tdzb";
      }

      if (layer == "ygbghtg") {
        layer = "tdzb";
      }

      if (layer == "ynrzbjhjd") {
        layer = "tdzb";
      }

      if (layer == "yghgg") {
        layer = "tdzb";
      }

      if (layer == "ybqbcazxyxynrgs") {
        layer = "tdzb";
      }

      if (layer == "yssfagg") {
        layer = "tdzb";
      }

      if (layer == "qt") {
        layer = "tdzb";
      }
      return layer;
    },
    async drawParkByLayerAndShowPopLayer(layer, lng, lat) {
      if (layer.startsWith("custom_project_")) {
        return this.$toasted.error("该范围不可用!", {
          position: "top-center",
          duration: 2000,
        });
      }
      layer = this.changeLayerName(layer);
      const data = await this.drawParkByLayer(layer, lng, lat, false);
      if (data.length > 0) {
        // 存起来
        this.$refs.projectContainerRef.putProjectOne(data);
      } else {
        if (
          this.moveCheckVals[this.moveCheckValsLength] &&
          this.moveCheckVals[this.moveCheckValsLength]["keyName"]
        ) {
          try {
            this.moveCheckValsLength--;
            this.drawParkByLayerAndShowPopLayer(
              this.moveCheckVals[this.moveCheckValsLength]["keyName"],
              lng,
              lat
            );
          } catch (error) { }
        }
      }
    },

    async getPoiName(lnglat) {
      // 确保 AMap 已加载
      if (typeof window === 'undefined' || !window.AMap) {
        console.warn('AMap 尚未加载完成');
        return;
      }
      AMap.plugin("AMap.Geocoder", () => {
        let geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          city: "010",
        });
        geocoder.getAddress(lnglat, (status, result) => {
          if (status === "complete" && result.info === "OK") {
            // result为对应的地理位置详细信息
            this.pop_setting_formataddr && this.pop_setting_formataddr.remove();
            this.pop_setting_formataddr = new mapboxgl.Popup({
              offset: 30,
              closeOnClick: false,
            })
              .setLngLat(lnglat)
              .setHTML(
                `<p class="setting-formataddr">详细地址：${result.regeocode.formattedAddress}</p>
                                  `
              )
              .addTo(this.building);
            $(".setting-formataddr")
              .closest(".mapboxgl-popup-content")
              .find(".mapboxgl-popup-close-button")
              .off("click")
              .on("click", () => {
                this.centerPoint.remove();
              });
          }
        });
      });
    },
    // 获取企业园区信息
    async flyToParkLnt(item) {
      const res = await searchParkLocation({ id: item.id });
      const lnt = res.data[0];
      this.setZoomAndCenter(18, [lnt.st_x, lnt.st_y]);
      setTimeout(() => {
        this.showLocationSuccss({
          title: `已为您定位到${res.data[0].name}`,
          message: `位置：${res.data[0].address}`,
          type: "success",
          timeout: 15000,
        });
      }, 5000);
    },
    // 隐藏案例
    hideCase() {
      this.iframeUrlCase = "";
      this.$refs.enterRef.showOnBtn();
      this.showResize = false;
      this.persplit = 100;
      setTimeout(() => {
        this.$nextTick(() => {
          this.resize();
        });
      }, 500);
    },
    hideVR() {
      this.iframeUrl = "";
      this.$refs.enterRef.showOnBtn();
      this.showResize = false;
      this.persplit = 100;
      setTimeout(() => {
        this.$nextTick(() => {
          this.resize();
        });
      }, 500);
    },
    doVRURL({ prop, lnglat }) {
      this.persplit = 50;
      this.showResize = true;
      this.iframeUrl = `https://www.720real.com/tour3/${prop.scene_viewid}`;
      this.$nextTick(() => {
        this.$refs.enterRef.hideOnBtn();
        this.building.resize();
        this.setCenter(lnglat);
        this.listemRotate(lnglat.lng, lnglat.lat);
      });
    },
    openJieJingView() {
      // https://api.map.baidu.com/panorama/v2?width=512&height=256&location=113.94563077274017,22.5353444034467&ak=qbR8UzgxC5cxc0Rl4idAt7jpzvhyCqCQ
      // 将鼠标变成旋转的小人
      // 点击地图打开端口
      this.isJieJingView = true;
    },
    closeJieJingView() {
      this.isJieJingView = false;
    },
    listenBadiDuMove(e) {
      if (this.baidu_pop_choose && this.baidu_pop_choose.remove) {
        this.baidu_pop_choose.remove();
        this.baidu_pop_choose = null;
      }
      this.building.getCanvas().style.cursor =
        'url("https://qntz.pcmxj.com/wxapp_static/st-scout(1).png"),  auto';
      clearTimeout(this.moveTimer);
      this.moveTimer = setTimeout(() => {
        // Trigger custom mousemoveend event
        this.building.fire("mousemoveend", e);
        clearTimeout(this.moveTimer);
      }, 200); // Adjust the delay according to your needs
    },
    doJieJingURL(lnglat) {
      // 标记
      this.toPlaceAndPoint(lnglat);
      let that = this;
      if (!this.showResize) {
        this.persplit = 50;
        this.showResize = true;
        this.iframeUrl = `https://cyy.pcmxj.com/jiedao.html?lng=${lnglat[0]}&lat=${lnglat[1]}`;
        this.$nextTick(() => {
          this.$refs.enterRef.hideOnBtn();
          this.building.resize();
          this.listemRotate();
        });
      } else {
        let childFrame = this.$refs.frameRef;
        childFrame.contentWindow.postMessage(
          { lng: lnglat[0], lat: lnglat[1] },
          "*"
        );
      }
    },
    getCommonParams() {
      return {
        center: [this.clickLngLat.lng, this.clickLngLat.lat],
        zoom: this.zoom,
        pitch: 0,
        bearing: 0,
        rotation: 0,
        minZoom: 10,
        maxZoom: 22,
      };
    },
    handleZoom() {
      this.building.on("zoom", (e) => {
        const zoom = this.building.getZoom();
        if (zoom > 21) {
          const mapboxCenter = this.building.getCenter();
          this.map.setZoom(21);
          this.building.setZoom(20);
          this.map.setZoomAndCenter(zoom + 1, [
            mapboxCenter.lng,
            mapboxCenter.lat,
          ]);
          return false;
        }
        if (zoom < 14) {
          this.building.setLayoutProperty("fanwei", "visibility", "visible");
        } else {
          this.building.setLayoutProperty("fanwei", "visibility", "none");
        }
        this.setZoomAndCenter(zoom);
      });
    },
    setZoomAndCenter(zoom, center) {
      if (center) {
        this.building.flyTo({
          center,
          zoom,
        });
        this.map.setZoom(zoom + 1);
        this.map.panTo(center);
      } else {
        const mapboxCenter = this.building.getCenter();
        this.map.setZoomAndCenter(zoom + 1, [
          mapboxCenter.lng,
          mapboxCenter.lat,
        ]);
      }
    },

    setCenter(center) {
      this.building.setCenter(center);
      this.map.setCenter([center.lng, center.lat]);
    },

    deepClone(obj) {
      let objClone = Array.isArray(obj) ? [] : {};
      if (obj && typeof obj === "object") {
        for (let key in obj) {
          if (obj[key] && typeof obj[key] === "object") {
            objClone[key] = this.deepClone(obj[key]);
          } else {
            objClone[key] = obj[key];
          }
        }
      }
      return objClone;
    },
    // 获取园区
    async handleFindParks(queryString, cb) {
      // const res = await searchPark({keyword: queryString, area: ''})
      if (queryString.length > 1) {
        if (this.keyTypeSelect == 1) {
          await axios
            .get(
              `https://restapi.amap.com/v3/assistant/inputtips?keywords=${queryString}&key=9139fdb1283e61e9a067295df8813a36&city=深圳&citylimit=true&datatype=all`
            )
            .then((res) => {
              let arr = res.data.tips.map((item) => {
                return {
                  address: item.district + item.address,
                  value: item.name,
                  location: item.location,
                };
              });
              cb(arr);
            });
        } else if (this.keyTypeSelect == 2) {
          const res = await enterpriseSearch({
            keyword: queryString,
            is_total: 1,
          });
          const arr = res.data.items.map((item) => {
            return {
              value: item.name,
              address: item.credit_no,
              credit_no: item.credit_no,
            };
          });
          cb(arr);
        }
      } else {
        cb([]);
      }
    },

    handleBias() {
      this.building.on("move", this.onMove);
    },
    onMove(e) {
      const mapboxCenter = this.building.getCenter();
      this.map.setCenter([mapboxCenter.lng, mapboxCenter.lat]);
    },
    checkPointer(lngLat) {
      if (this.pop_choose && this.pop_choose.remove) {
        this.pop_choose.remove();
        this.pop_choose = null;
      }
      if (this.isViewData) {
        const hstr = `<div><span class="markerHear">查看图层或地块属性</span></div>`;
        this.pop_choose = new mapboxgl.Popup({
          className: "custom-popup-building",
          closeButton: false,
          closeOnClick: false,
          offset: 25,
        })
          .setLngLat(lngLat)
          .setHTML(hstr)
          .addTo(this.building);
        this.building.getCanvas().style.cursor =
          'url("https://qntz.pcmxj.com/wxapp_static/viewDatasdfad.png"),  auto';
      } else if (this.isMarker) {
        const hstr = `<div><span class="markerHear">标记点（选中标记后删除）</span></div>`;
        this.pop_choose = new mapboxgl.Popup({
          className: "custom-popup-building",
          closeButton: false,
          closeOnClick: false,
          offset: 25,
        })
          .setLngLat(lngLat)
          .setHTML(hstr)
          .addTo(this.building);
        this.building.getCanvas().style.cursor =
          'url("https://qntz.pcmxj.com/wxapp_static/asdfasfsadfasd.png"),  auto';
      } else if (this.isHourArea || this.isHourLine) {
        this.building.getCanvas().style.cursor = "crosshair";
        const hstr = `<div><span class="markerHear">绘制范围或线</span></div>`;
        this.pop_choose = new mapboxgl.Popup({
          className: "custom-popup-building",
          closeButton: false,
          closeOnClick: false,
          offset: 25,
        })
          .setLngLat(lngLat)
          .setHTML(hstr)
          .addTo(this.building);
      } else if (this.isProjectLayer) {
        this.building.getCanvas().style.cursor =
          'url("https://qntz.pcmxj.com/wxapp_static/selectedData.png"),  auto';
        const hstr = `<div><span class="markerHear">给项目添加图层</span></div>`;
        this.pop_choose = new mapboxgl.Popup({
          className: "custom-popup-building",
          closeButton: false,
          closeOnClick: false,
          offset: 25,
        })
          .setLngLat(lngLat)
          .setHTML(hstr)
          .addTo(this.building);
      } else if (this.isIn) {
        this.building.getCanvas().style.cursor =
          'url("https://qntz.pcmxj.com/wxapp_static/selectedData.png"),  auto';
        const hstr = `<div><span class="markerHear">双击可完成绘制</span></div>`;
        this.pop_choose = new mapboxgl.Popup({
          className: "custom-popup-building",
          closeButton: false,
          closeOnClick: false,
          offset: 25,
        })
          .setLngLat(lngLat)
          .setHTML(hstr)
          .addTo(this.building);
      } else {
        this.building.getCanvas().style.cursor = "";
        if (this.pop_choose && this.pop_choose.remove) {
          this.pop_choose.remove();
          this.pop_choose = null;
        }
      }
      setTimeout(() => {
        if (this.pop_choose && this.pop_choose.remove) {
          this.pop_choose.remove();
          this.pop_choose = null;
        }
      }, 3000);
    },
    async initSetting() {
      window.widget = PlotWidget.getInstance(this.building, {}, this);
      this.mapTool = new MapMeasureTool(this);
      this.mapTool.defButtonBeforeClick = () => {
        this.isPoint = true;
        this.isMarker = false;
      };

      this.mapTool.ddMarkClick = () => {
        if ($(".d3-image").length > 0) {
          this.building.setPitch(0);
          this.map.setPitch(0);
          this.$layer.msg("Tips：切换为2D平面地图", { icon: 6 });
        } else if ($(".d2-image").length > 0) {
          this.building.setPitch(45);
          this.map.setPitch(45);
          this.$layer.msg(
            "Tips：切换为3D平面地图,按住Ctrl + 鼠标左键可旋转调整位置哦",
            { icon: 6 }
          );
        }
      };

      this.mapTool.translateButtonClick = () => {
        this.isPoint = true;
        // this.isViewData = false;
        this.isMarker = false;
        if (this.$refs.operationPop) {
          this.$refs.operationPop.hidePop();
        }

        if ($("#mapboxglTranslate").hasClass("active")) {
          this.$refs.layerComp.showPop();
        } else {
          this.$refs.layerComp.hidePop();
        }
      };

      this.mapTool.mapboxglXiangmuButton = () => {
        this.isPoint = false;
        // this.isViewData = false;
        this.isMarker = false;
        this.$refs.operationPop.hidePop();
        this.$refs.layerComp.hidePop();
        this.building.setPitch(0);
        this.map.setPitch(0);
        if ($("#mapboxglXiangmu").hasClass("active")) {
          this.$refs.projectContainerRef.showPop();
        } else {
          this.$refs.projectContainerRef.hidePop();
        }
      };

      this.mapTool.lineButtonClick = () => {
        if ($("#mapboxglLine").hasClass("active")) {
          this.isHourArea = false;
          this.isHourLine = true;
          this.isMarker = false;
          // this.isViewData = false;
          this.isPoint = false;
        } else {
          this.isHourArea = false;
          this.isHourLine = false;
          this.isMarker = false;
          this.isViewData = false;
          this.isPoint = true;
        }
      };

      this.mapTool.areaButtonClick = () => {
        if ($("#mapboxglArea").hasClass("active")) {
          this.isHourArea = true;
          this.isHourLine = false;
          this.isMarker = false;
          // this.isViewData = false;
          this.isPoint = false;
        } else {
          this.isHourArea = false;
          this.isHourLine = false;
          this.isMarker = false;
          // this.isViewData = false;
          this.isPoint = true;
        }
      };

      this.mapTool.fenxiButtonBeforeClick = () => {
        this.isHourLine = false;
        this.isHourArea = false;
        // this.isViewData = false;
        this.isMarker = false;
        this.$refs.wxLocationRef.hidePop();
        this.$refs.layerComp.hidePop();
        this.$refs.projectContainerRef.hidePop();
        if ($("#mapboxglfenxi").hasClass("active")) {
          this.$refs.operationPop.showPop();
        } else {
          this.$refs.operationPop.hidePop();
        }
      };
      this.mapTool.lineButtonBeforeClick = () => {
        this.isPoint = true;
        this.isMarker = false;
        this.$refs.wxLocationRef.hidePop();
      };

      this.mapTool.areaButtonBeforeClick = () => {
        this.isPoint = true;
        this.isMarker = false;
        this.$refs.wxLocationRef.hidePop();
      };

      this.mapTool.viewDataButtonBeforeClick = () => {
        this.isHourArea = false;
        this.isHourLine = false;
        this.isMarker = false;
        if (!$("#mapboxglXiangmu").hasClass("active")) {
          this.isProjectLayer = false;
        }
        // this.mapMeasureDrawTool.trash()
        this.$refs.wxLocationRef.hidePop();
        if ($("#mapboxglViewData").hasClass("active")) {
          this.isViewData = true;
          this.isPoint = false;
          let layid = this.$layer.msg(
            "Tips：点击建筑或图层可查看属性,右键可清除标记物",
            { icon: 6, time: 5000 }
          );
          setTimeout(() => {
            this.$layer.close(layid);
          }, 5000);
        } else {
          this.isPoint = true;
          // this.isViewData = false;
        }
      };
      this.mapTool.currentButtonBeforeClick = async () => {
        this.$refs.wxLocationRef.showPop();
      };

      this.mapTool.markPositionClick = async () => {
        if ($("#markPosition").hasClass("active")) {
          //进行标记
          let layid = this.$layer.msg("Tips：右键可清除标记物", {
            icon: 6,
            time: 5000,
          });
          setTimeout(() => {
            this.$layer.close(layid);
          }, 5000);
          this.isHourLine = false;
          this.isHourArea = false;
          this.isViewData = false;
          this.isPoint = false;
          this.isMarker = true;
        } else {
          this.isMarker = false;
        }
      };

      this.mapTool.finished = (points) => {
        this.parkInfo = {};
        this.parkInfo.layerName = "区域选址";
        this.parkInfo.points = points;
        this.$refs.enterRef.setParkInfo(this.parkInfo);
        this.$refs.enterRef.showPop();
        this.isHourArea = false;
        this.isHourLine = false;
      };
      this.handleZoom();
      this.handleBias();
      this.handleMouseInner();
      // 加载法定图则图层
      this.initArcGisLayer();
    },
    // 点击标记给地图标记
    addMarkerToMap(longitude, latitude) {
      let that = this;
      // 创建标记并将其添加到地图上
      const hstr = `删除`;
      let item = {
        lnglat: [longitude, latitude],
        marker: new mapboxgl.Marker({
          draggable: false,
          color: "rgb(61,147,253)",
        })
          .setLngLat([longitude, latitude]) // 设置标记的经纬度位置
          .addTo(this.building),
        pop: new mapboxgl.Popup({
          className: "custom-popup-building close_d",
          closeButton: false,
          closeOnClick: false,
          offset: 35,
        })
          .setLngLat([longitude, latitude])
          .setHTML(hstr)
          .addTo(that.building),
      };
      this.markerList.push(item);
      $(item.pop.getElement())
        .off("click")
        .on("click", function () {
          item.marker.remove();
          item.pop.remove();
        });
    },
    disCovered(parkInfo) {
      this.parkInfo = parkInfo;
      this.$refs.enterRef.setParkInfo(this.parkInfo);
      this.draw_st_asgeojson(
        JSON.stringify({ type: "Polygon", coordinates: [parkInfo.points] })
      );
      this.$refs.enterRef.showPop();
    },
    switchPoint(val) {
      switch (val) {
        case "测面 （使用后双击地图标记）":
          return "crosshair";
        case "测距 （使用后双击地图标记）":
          return "crosshair";
        case "标记 （鼠标左键）":
          return "";
        case "查看地块信息":
          return "pointer";
        default:
          return "";
      }
    },
    mergePoints(data, threshold = 0.00001) {
      // 合并接近的坐标，并计算数量
      const mergedData = data.reduce((result, item) => {
        const found = result.find(
          (r) =>
            Math.abs(r.value[0] - item.value[0]) < threshold &&
            Math.abs(r.value[1] - item.value[1]) < threshold
        );
        if (found) {
          found.count++;
          found.companies.push(item);
        } else {
          result.push({ ...item, count: 1, companies: [item] });
        }
        return result;
      }, []);
      return mergedData.map((item) => {
        return {
          value: [item.value[0], item.value[1], item.count],
          name: item.companies,
        };
      });
    },


    backNearCompanies(points) {

      // 如果points1存在
      if (this.building.getSource('points-a')) {
        // 删除图层
        this.building.removeLayer('pointClusters-a');
        this.building.removeLayer('cluster-count-a');
        this.building.removeLayer('unclustered-points-a');

        // 删除Source
        this.building.removeSource('points-a');

      }

      this.building.addSource('points-a', {
        type: 'geojson',
        cluster: true, // 开启聚合
        clusterMaxZoom: 14, // 最大聚合层级
        clusterRadius: 50, // 聚合半径
        data: {
          type: 'FeatureCollection',
          features: points.map(item => {
            let lnglat = this.sumPoints(item.shape_text)
            return {
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: [lnglat[0], lnglat[1]] // 经纬度
              },
              properties: item
            }
          })
        }
      });


      this.building.addLayer({
        id: 'pointClusters-a',
        type: 'circle',
        source: 'points-a',
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': '#FF3333',
          'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40]
        }
      })

      this.building.addLayer({
        id: 'cluster-count-a',
        type: 'symbol',
        source: 'points-a',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12
        }
      })

      // 根据数据源添加图层
      this.building.addLayer({
        id: 'unclustered-points-a',
        type: 'circle',
        source: 'points-a',
        filter: ['!', ['has', 'point_count']], // 只显示未聚合的图层
        paint: {
          'circle-color': '#FF3333', // 设置图层颜色
          'circle-radius': 6,
          'circle-stroke-width': 1,
          'circle-stroke-color': '#fff'
        }
      });


    },

    doDragPanel() {
      //获取元素
      // var dv = document.getElementById('boxWDC');
      // var dropEle = $('#tuodongWrap').get(0)
      // var dv = $('.mapboxgl-popup').eq(0).get(0)
      setTimeout(() => {
        var dv = $(".mapboxgl-popup").eq(0).get(0);
        var x = 0;
        var y = 0;
        var l = 0;
        var t = 0;
        var isDown = false;
        $("#tuodongWrap").mousedown(function (e) {
          x = e.clientX;
          y = e.clientY;

          l = dv.offsetLeft;
          t = dv.offsetTop;
          isDown = true;
        });

        $(document).mousemove(function (event) {
          if (isDown == false) {
            return;
          }
          var nx = event.clientX;
          var ny = event.clientY;
          var nl = nx - (x - l);
          var nt = ny - (y - t);
          if (!isNaN(event.clientX) && !isNaN(event.clientY)) {
            $(".mapboxgl-popup")
              .eq(0)
              .css("left", nl + "px");
            $(".mapboxgl-popup")
              .eq(0)
              .css("top", nt + "px");
          }
        });
        $(document).mouseup(function (event) {
          isDown = false;
          // $(document).unbind("mousemove");
        });
      });
    },
    formatJsonToHtml(code, json, buildInfo, lng, lat) {
      const buildKeys = json[code];
      let html =
        "<div class='box-w' id='boxWDC'><img title='拖拽可移动面板' src='https://qntz.pcmxj.com/wxapp_static/tuodongccccccc.png' id='tuodongWrap' class='tuodong-wrap'/>";

      // 二维码图片
      // https://api.pwmqr.com/qrcode/create/?url=https%3A%2F%2Fwww.pwmqr.com
      if (lng && lat) {
        let url = `${`https://cyy.pcmxj.com/mini-zgsz/#/map?layer=${code}&lng=${lng}&lat=${lat}`}`;
        // urlencode
        url = encodeURIComponent(url);
        html += `<div class="build-item">
                <div class="build-item
                -prfex" >二维码:</div>
                <div class="build-item
                -last"><img src="${`https://api.pwmqr.com/qrcode/create/?url=${url}`}" alt="二维码" style="width: 100px;height: 100px;"/></div>
                </div>`;
      }

      for (let key in buildKeys) {
        let value = buildKeys[key];

        if (
          value.includes("面积") &&
          value != "实施面积" &&
          value != "留用地面积" &&
          !value.includes("km²") &&
          buildInfo[key] != null
        ) {
          buildInfo[key] += " ㎡";
        } else if (key == "layerName") {
          buildInfo[key] = value;
          value = "所属图层";
        } else if (value.includes("规划容积") && buildInfo[key] != null) {
          buildInfo[key] += "㎡";
        } else if (
          (value.includes("价") || value.includes("费用")) &&
          buildInfo[key] != null
        ) {
          buildInfo[key] += "元";
        } else if (
          (value.includes("高层") ||
            value.includes("多层") ||
            value.includes("低密度")) &&
          buildInfo[key] != null
        ) {
          buildInfo[key] += "元/m²·月";
        } else if (
          (value.includes("高") ||
            (value.includes("范围") && value != "所属范围")) &&
          buildInfo[key] != null
        ) {
          buildInfo[key] += "米";
        } else if (
          value.includes("率") &&
          !value.includes("容积率") &&
          buildInfo[key] != null
        ) {
          buildInfo[key] += "%";
        } else if (value.includes("层数") && buildInfo[key] != null) {
          buildInfo[key] += "层";
        }
        if (
          value.includes("名称") &&
          value !== "用户名称" &&
          value !== "分支名称"
        ) {
          if (buildInfo[key]) {
            html += `<div class="makerTop"><h2 class="markerHear">${buildInfo[key]}</h2></div>`;
          }
        } else {
          if (buildInfo[key]) {
            html += `<div class="build-item">
                <div class="build-item-prfex" >${buildInfo[key] ? value + ":" : ""
              }</div>
                <div class="build-item-last">${buildInfo[key] && buildInfo[key].indexOf("undefined") == -1
                ? this.formatInfo(value, buildInfo[key])
                : ""
              }</div>
                </div>`;
          } else {
            html += `<div class="build-item">
                <div class="build-item-prfex" >${value + ":"}</div>
                <div class="build-item-last">${buildInfo[key] && buildInfo[key].indexOf("undefined") == -1
                ? this.formatInfo(value, buildInfo[key])
                : ""
              }</div>
                </div>`;
          }
        }
      }

      html += "</div>";
      return html;
    },
    formatInfo(value, attr) {
      if (value.includes("实施面积")) {
        return Number(attr).toFixed(2) + "公顷";
      }
      if (value.includes("留用地面积")) {
        return Number(attr).toFixed(2) + "㎡";
      }
      return attr;
    },
    // TODO
    // 监听屏幕旋转
    listemRotate(longitude, latitude) {
      let that = this;
      window.addEventListener("message", function (event) {
        // 处理 iframe 内部事件的代码
        // that.building.rotateTo(event.data)
        // const bearing = that.building.getBearing()
        // that.map.setRotation(-bearing)
        if (longitude && latitude) {
          const rotationAngleDegrees = parseInt(event.data) - 45; // 旋转角度（度数）
          const rotationAngleRadians =
            (rotationAngleDegrees * (Math.PI * 2)) / 360; // 将度数转换为弧度
          that.createRotatableSector(
            [longitude, latitude],
            rotationAngleRadians
          );
        } else {
          var lanlat = event.data.split(",");
          that.toPlaceAndPoint(lanlat);
        }
      });
    },

    calculateRotatedSector(
      center,
      radius,
      startAngle,
      endAngle,
      rotationAngle
    ) {
      const angleStep = (Math.PI * 2) / 360; // 每度的弧度值
      const coordinates = [];

      // 添加中心点
      coordinates.push(center);

      for (let angle = startAngle; angle <= endAngle; angle += angleStep) {
        const x = center[0] + radius * Math.cos(angle - rotationAngle);
        const y = center[1] + radius * Math.sin(angle - rotationAngle);
        coordinates.push([x, y]);
      }

      // 添加终点以闭合扇形
      coordinates.push(center);

      return coordinates;
    },
    createRotatableSector(center, rotationAngle) {
      // 计算扇形的边界坐标并根据旋转角度进行旋转
      const radius = 0.004; // 扇形半径，单位为米
      const startAngle = 0; // 扇形的起始角度（弧度）
      const endAngle = (90 * (Math.PI * 2)) / 360; // 扇形的终止角度（弧度）
      const coordinates = this.calculateRotatedSector(
        center,
        radius,
        startAngle,
        endAngle,
        rotationAngle
      );

      if (this.building.getSource("sector-source")) {
        this.building.removeLayer("sector-layer");
        this.building.removeSource("sector-source");
      }
      // 创建扇形的 GeoJSON 数据
      const sectorData = {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: [coordinates],
        },
      };

      // 添加扇形的数据源到地图
      this.building.addSource("sector-source", {
        type: "geojson",
        data: sectorData,
      });

      // 添加图层绘制扇形
      this.building.addLayer({
        id: "sector-layer",
        type: "fill",
        source: "sector-source",
        paint: {
          "fill-color": "rgba(0, 128, 255, 0.5)", // 填充颜色
          "fill-opacity": 0.7, // 填充透明度
        },
      });
    },
    formatJsonToHtml1(code, json, buildInfo) {
      const buildKeys = json[code];
      let html = "<div class='box-w'>";
      for (let key in buildKeys) {
        let value = buildKeys[key];
        if (value.includes("名称")) {
          if (buildInfo[key]) {
            html += `<div class="makerTop"><span class="markerHear">${buildInfo[key]}</span></div>`;
          }
        }
      }
      html += "</div>";
      return html;
    },

    handleMouseInner() {
      this.building.on("wheel", (event) => {
        this.building.stop();
      });
      this.building.on("mousemove", (e) => {
        this.checkPointer(e.lngLat);
        let point = e.point;
        if (this.isJieJingView) {
          // 查看街景VR
          this.listenBadiDuMove(e);
        } else {
          if (this.baidu_pop_choose && this.baidu_pop_choose.remove) {
            this.baidu_pop_choose.remove();
            this.baidu_pop_choose = null;
            this.building.getCanvas().style.cursor = "";
          }
          let features = this.building.queryRenderedFeatures(point, {
            layers: this.defaultFeatures,
          });
          if (
            features[0] &&
            features[0].sourceLayer &&
            Object.keys(sourceLayerJson).findIndex(
              (item) => item == features[0].sourceLayer
            ) > -1 &&
            !this.isHoverUnclustered
          ) {
            this.building.getCanvas().style.cursor = "pointer";
            let buildInfo = features[0].properties;
            let sourceLayer = features[0].sourceLayer;

            const hstr = this.formatJsonToHtml1(
              sourceLayer,
              sourceLayerJson,
              buildInfo
            );

            if (sourceLayer == "buildings") {
              this.isHouer3D = true;
            }
            if (this[`popDesc_${sourceLayer}`]) {
              Object.keys(sourceLayerJson).forEach(
                (item) =>
                  this[`popDesc_${item}`] && this[`popDesc_${item}`].remove()
              );
              this[`popDesc_${sourceLayer}`] = null;
            }

            this[`popDesc_${sourceLayer}`] = new mapboxgl.Popup({ offset: 25 })
              .setLngLat(e.lngLat)
              .setHTML(hstr)
              .addTo(this.building);

            if (this[`feature_${sourceLayer}_Id`]) {
              this.building.removeFeatureState(
                {
                  source: sourceLayer == "buildings" ? "data" : sourceLayer,
                  id: this[`feature_${sourceLayer}_Id`],
                  sourceLayer: sourceLayer,
                },
                "hover"
              );
              this[`feature_${sourceLayer}_Id`] = null;
            }

            this[`feature_${sourceLayer}_Id`] = features[0].id;
            if (this[`feature_${sourceLayer}_Id`]) {
              this.building.setFeatureState(
                {
                  source: sourceLayer == "buildings" ? "data" : sourceLayer,
                  id: this[`feature_${sourceLayer}_Id`],
                  sourceLayer: sourceLayer,
                },
                { hover: true }
              );
            }
          }
        }
      });

      this.building.on("mousemoveend", (e) => {
        let location = e.lngLat;
        let cover_img = `https://api.map.baidu.com/panorama/v2?width=512&height=256&location=${location.lng},${location.lat}&ak=71de10dc4d8972f7efb90faa1514d931`;
        const hstr = `<div>
                          <div><img src="${cover_img}" id="baiduImage" style="width:100px;height:75px;" onerror="handleImageError()"/></div>
                      </div>`;
        this.baidu_pop_choose = new mapboxgl.Popup({
          className: "custom-popup-baidu",
          closeButton: false,
          closeOnClick: false,
          offset: 25,
        })
          .setLngLat(location)
          .setHTML(hstr)
          .addTo(this.building);
      });

      Object.keys(sourceLayerJson).forEach((item) => {
        this.building.on("mouseleave", item, (e) => {
          // this.building.getCanvas().style.cursor = this.switchPoint($('.mapboxgl-ctrl-group .active').attr('title'));
          if (item == "buildings") {
            this.isHouer3D = false;
          }
          if (!this.isHouer3D) {
            this[`popDesc_${item}`] && this[`popDesc_${item}`].remove();
            this[`popDesc_${item}`] = null;
            if (this[`feature_${item}_Id`]) {
              this.building.removeFeatureState(
                {
                  source: item == "buildings" ? "data" : item,
                  id: this[`feature_${item}_Id`],
                  sourceLayer: item,
                },
                "hover"
              );
            }
          }
        });
      });

      this.building.on("rotate", (e) => {
        const bearing = this.building.getBearing();
        this.map.setRotation(-bearing);
      });

      this.building.on("pitch", (e) => {
        const pitch = this.building.getPitch();
        this.map.setPitch(pitch);
      });

      this.mapEvents.forEach((eve) => {
        this.building.on(eve, (e) => {
          let point = e.point;
          if (this.isJieJingView) {
            this.doJieJingURL([e.lngLat.lng, e.lngLat.lat]);
          } else if (
            this.isPoint &&
            !this.isHoverUnclustered &&
            !this.isProjectLayer
          ) {
            // this.clickLngLat = e.lngLat
            let features = null;
            if (this.building.getLayer("pointClusters")) {
              features = this.building.queryRenderedFeatures(point, {
                layers: [
                  "cluster-count",
                  "pointClusters",
                  ...this.defaultFeatures,
                ],
              });
            } else {
              features = this.building.queryRenderedFeatures(point, {
                layers: this.defaultFeatures,
              });
            }

            if (features[0] && (features[0].layer.id == "cluster-count" || features[0].layer.id == "pointClusters")) {
              return false;
            }


            if (features.length > 0) {
              let arr = [];
              features.forEach((item) => {
                let da = Object.keys(sourceLayerJson).find(
                  (data) => data == item.sourceLayer
                );
                if (da) {
                  arr.push({ ...sourceLayerJson[da], ...item });
                }
              });

              if (arr && arr.length > 0 && arr[0].id) {
                // this.parkInfo = e.features[0].properties
                this.parkInfo = arr[0].properties;
                this.parkInfo.layerName = arr[0].layerName;
                this.parkInfo.layer_id = arr[0].id;
                this.parkInfo.layer_name = arr[0].sourceLayer;
                this.clearPoint();
                arr[0].sourceLayer = this.changeLayerName(arr[0].sourceLayer);
                this.drawParkByLayer(
                  arr[0].sourceLayer,
                  e.lngLat.lng,
                  e.lngLat.lat
                );

                // this.isViewData = true;
                // this.isPoint = false;
                this.moveCheckValsLength = this.moveCheckVals.length - 1;
                this.drawParkByLayerAndShowPop(
                  this.moveCheckVals[this.moveCheckValsLength]["keyName"],
                  e.lngLat.lng,
                  e.lngLat.lat
                );

                this.$refs.enterRef.setParkInfo(this.parkInfo);
                this.$refs.enterRef.showPop();
                // this.setZoomAndCenter(17, [e.lngLat.lng, e.lngLat.lat]);
              } else {
                // this.isViewData = true;
                this.isPoint = false;
                this.moveCheckValsLength = this.moveCheckVals.length - 1;
                this.drawParkByLayerAndShowPop(
                  this.moveCheckVals[this.moveCheckValsLength]["keyName"],
                  e.lngLat.lng,
                  e.lngLat.lat
                );
                this.$refs.enterRef.setParkInfo(this.parkInfo);
              }
            } else {
              this.isViewData = true;
              // this.isPoint = false;
              this.moveCheckValsLength = this.moveCheckVals.length - 1;
              this.drawParkByLayerAndShowPop(
                this.moveCheckVals[this.moveCheckValsLength]["keyName"],
                e.lngLat.lng,
                e.lngLat.lat
              );

              this.$refs.enterRef.setParkInfo(this.parkInfo);
            }
          } else if (this.isViewData && !this.isProjectLayer) {
            if (this.moveCheckVals.length > 0) {
              this.moveCheckValsLength = this.moveCheckVals.length - 1;
              this.drawParkByLayerAndShowPop(
                this.moveCheckVals[this.moveCheckValsLength]["keyName"],
                e.lngLat.lng,
                e.lngLat.lat
              );
              // this.parkInfo
              this.parkInfo = {};
              this.parkInfo.layerName =
                this.moveCheckVals[this.moveCheckValsLength]["layerName"];
              this.parkInfo.layer_id = "";
              this.parkInfo.layer_name =
                this.moveCheckVals[this.moveCheckValsLength]["keyName"];

              // leon console.log("this.parkInfo", this.parkInfo);
              this.$refs.enterRef.setParkInfo(this.parkInfo);
            }
          } else if (this.isProjectLayer) {
            let layers = this.building.getStyle().layers;
            let layerIds = layers.map((item) => {
              return item.id;
            });
            if (
              layerIds.findIndex((item) => item.indexOf("gl-draw-polygon")) > -1
            ) {
              let features = this.building.queryRenderedFeatures(point, {
                layers: [
                  "gl-draw-polygon-stroke-inactive.cold",
                  "gl-draw-polygon-stroke-active.cold",
                  "gl-draw-polygon-fill-active.cold",
                  "gl-draw-polygon-fill-inactive.cold",
                ],
              });
              if (features.length == 0) {
                this.moveCheckValsLength = this.moveCheckVals.length - 1;
                this.drawParkByLayerAndShowPopLayer(
                  this.moveCheckVals[this.moveCheckValsLength]["keyName"],
                  e.lngLat.lng,
                  e.lngLat.lat
                );
              }
            }
          } else if (this.isMarker) {
            this.addMarkerToMap(e.lngLat.lng, e.lngLat.lat);
          }
        });
      });

      this.building.on("contextmenu", (e) => {
        let point = e.point;
        let features = this.building.queryRenderedFeatures(point);
        let params = {};
        if (features.length > 0) {
          if (features[0].source == "mapbox-gl-draw-cold") {
            // 导出画图的企业名录
            params.coordinates = features[0].geometry.coordinates[0];
            params.featureId = features[0].properties.id;
          } else {
            let arr = [];
            features.forEach((item) => {
              let da = Object.keys(sourceLayerJson).find(
                (data) => data == item.sourceLayer
              );
              if (da) {
                arr.push({ ...sourceLayerJson[da], ...item });
              }
            });

            if (arr && arr.length > 0 && arr[0].id) {
              this.layerId = arr[0].id;
              this.layer_name = arr[0].sourceLayer;
              this.layerName = arr[0].layerName;
            } else {
              this.layerId = "";
              this.layer_name = "";
              this.layerName = "";
            }
          }
        } else {
          this.layerId = "";
          this.layer_name = "";
          this.layerName = "";
        }

        let menuEvent = [
          {
            fnName: "exportCompanies",
            params: params,
            isShow: true,
            icoName: "el-icon-takeaway-box",
            btnName: "导出企业",
          },
          {
            fnName: "clearPoint",
            params: params,
            isShow: true,
            icoName: "el-icon-delete-location",
            btnName: "清除标记物",
          },
        ];
        if (this.isIn) {
          menuEvent.push({
            fnName: "stopDraw",
            params: params,
            isShow: true,
            icoName: "el-icon-news",
            btnName: "取消绘制",
          });
        }
        this.rightclickInfo = {
          position: {
            x: e.point.x,
            y: e.point.y - 60,
          },
          menulists: menuEvent,
        };
      });
    },
    // 是否深圳500强
    enterPriseTopChange({ keyName, layerName }) {
      this.clearPoint();
      this.parkInfo = {};
      this.parkInfo.layerName = layerName;
      this.parkInfo.layer_id = "";
      this.parkInfo.layer_name = keyName;
      this.clearPoint();
      if (this.st_asgeojson) {
        // this.building.removeLayer('maine')
        this.building.removeLayer("outline");
        this.building.removeSource("maine");
      }
      this.$refs.enterRef.setParkInfo(this.parkInfo);
      this.$refs.enterRef.showPop();
    },
    async exportCompanies(params) {
      if (params.coordinates) {
        await this.$refs.enterRef.exportByDraw({ points: params.coordinates });
      } else {
        await this.$refs.enterRef.exportCompanies({
          layer_id: this.layerId,
          layer_name: this.layer_name,
          layerName: this.layerName,
        });
      }
    },
  },
};
